/*const getPaths = () => {
  const dashboard = [
    {
      _name: 'CSidebarNavItem',
      name: 'Dashboard',
      to: '/dashboard',
      icon: 'cil-speedometer'
    }
  ]

  const occupancy = [
    {
      _name: 'CSidebarNavItem',
      name: 'Occupancy',
      to: '/occupancy',
      icon: 'cil-speedometer'
    }
  ]

  const standard = [
    {
      _name: 'CSidebarNavItem',
      name: 'Assets',
      to: '/assets',
      icon: 'cil-layers'
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'World',
      to: '/world',
      icon: 'cil-cursor',
      items: [
        {
          name: 'Assets',
          to: '/world'
        },
        {
          name: 'Zones',
          to: '/world/zones'
        }
      ]
    },
    {
      _name: 'CSidebarNavItem',
      name: 'Zones',
      to: '/zones',
      icon: 'cil-border-clear'
    },
    {
      _name: 'CSidebarNavItem',
      name: 'Groups',
      to: '/groups',
      icon: 'cil-industry'
    }
  ]

  return [{
    _name: 'CSidebarNav',
    _children: [
      ...dashboard,
      ...occupancy,
      ...standard
    ]
    //...(store.getters.isAdmin() ? admin : []),
    //...(store.getters.isOper() || store.getters.isAdmin() ? oper : []),
    //...user
  }]
}

export default getPaths
*/

export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer',
        module: 'tracking'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Contractors',
        to: '/contractors',
        icon: 'cil-speedometer',
        module: 'contractors'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Poles',
        to: '/poles',
        icon: 'cil-location-pin',
        module: 'poles'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Assets',
        to: '/assets',
        icon: 'cil-layers'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Buildings',
        to: '/building',
        icon: 'cil-building',
        module: 'building'
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'World',
        to: '/world',
        icon: 'cil-cursor',
        module: 'tracking',
        items: [
          {
            name: 'Assets',
            to: '/world'
          },
          {
            name: 'Zones',
            to: '/world/zones'
          }
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Zones',
        to: '/zones',
        icon: 'cil-border-clear',
        module: 'tracking'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Groups',
        to: '/groups',
        icon: 'cil-industry'
      }
    ]
  }
]
